export default "__VITE_ASSET__BstzWNsK__"